module.exports = __webpack_public_path__ + "static/img/cover.b78d35b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/panorama/cover.jpg
// module id = pDZ8
// module chunks = 0